import API from '../utils/api';

export const BRANCHES_GET = 'BRANCHES_GET';
export const BRANCHES_GET_SUCCESS = 'BRANCHES_GET_SUCCESS';
export const BRANCHES_GET_FAILED = 'BRANCHES_GET_FAILED';

export const getBranches = () => ({
    type: BRANCHES_GET
});

export const getBranchesSuccess = (branches) => ({
    type: BRANCHES_GET_SUCCESS,
    branches
});

export const getBranchesFailed = () => ({
    type: BRANCHES_GET_FAILED
});

export const getBranchesApi = () => (dispatch) => {
    dispatch(getBranches());

    return API.get('management/branches').then((res) => {
        if (res.status !== 200) {
            dispatch(getBranchesFailed());

            return;
        }

        res.json().then((json) => {
            dispatch(getBranchesSuccess(json.data));
        });
    });
};


/** WEBPACK FOOTER **
 ** ./src/actions/branches.js
 **/